import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import respondToMeetingMessageOperation from 'owa-service/lib/operation/respondToMeetingMessageOperation';
import respondToMeetingMessageRequest from 'owa-service/lib/factory/respondToMeetingMessageRequest';
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import itemId from 'owa-service/lib/factory/itemId';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import RespondToMeetingMessageResponse from 'owa-service/lib/contract/RespondToMeetingMessageResponse';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';

export default function respondToMeetingMessage(
    item: MeetingRequestMessageType,
    response: ResponseTypeType,
    sendResponse: boolean,
    responseMessage: string = ''
): Promise<RespondToMeetingMessageResponse> {
    return respondToMeetingMessageOperation({
        Header: getJsonRequestHeader(),
        Body: respondToMeetingMessageRequest({
            MeetingMessageId: itemId(item.ItemId),
            Response: response,
            SendResponse: sendResponse,
            Notes: bodyContentType({
                BodyType: 'HTML',
                Value: responseMessage,
            }),
        }),
    }).then(response => response.Body);
}
